import { Head, Link } from "@inertiajs/react"
import { GraduationCap, Play, ChevronRight } from "lucide-react"
import { CoachLayout } from "../components/CoachLayout"
import { SectionTabs } from "../components/SectionTabs"
import { Card, CardContent } from "@/components/ui/card"

const settingsTabs = [
  { label: "Settings", href: "/app/coach/settings" },
  { label: "Tutorials", href: "/app/coach/tutorial_videos" },
]

export default function TutorialVideosIndex({ currentUser, videos }) {
  return (
    <CoachLayout currentUser={currentUser}>
      <Head title="Tutorial Videos - Kingdom Factor" />

      <div className="space-y-6">
        <div>
          <h1 className="font-display text-2xl font-bold text-zinc-900">
            Tutorial Videos
          </h1>
          <p className="text-sm text-zinc-500 mt-1">
            Learn how to use every feature of the coach portal
          </p>
        </div>

        <SectionTabs tabs={settingsTabs} />

        <div className="space-y-2">
          {videos.map((video, index) => (
            <Link
              key={video.id}
              href={`/app/coach/tutorial_videos/${video.slug}`}
              className="block"
            >
              <Card className="hover:bg-zinc-50 transition-colors cursor-pointer">
                <CardContent className="flex items-center gap-4 py-4">
                  <div className="flex-shrink-0 w-10 h-10 rounded-full bg-kf-red/10 text-kf-red flex items-center justify-center">
                    <Play className="h-4 w-4 ml-0.5" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-zinc-900">
                      {index + 1}. {video.title}
                    </p>
                    {video.description && (
                      <p className="text-sm text-zinc-500 mt-0.5 line-clamp-1">
                        {video.description.split("\n")[0]}
                      </p>
                    )}
                  </div>
                  <ChevronRight className="h-5 w-5 text-zinc-400 flex-shrink-0" />
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        {videos.length === 0 && (
          <Card>
            <CardContent className="flex flex-col items-center justify-center py-12 text-center">
              <GraduationCap className="h-12 w-12 text-zinc-300 mb-3" />
              <p className="text-zinc-500">No tutorial videos available yet.</p>
            </CardContent>
          </Card>
        )}
      </div>
    </CoachLayout>
  )
}
